import { useContext } from 'react';

import { SignInContext } from '@modules/users';

const useCanUseAiQa = () => {
  const { organization, user } = useContext(SignInContext);

  return organization.featureSettings.aiQa?.enabled === true && user.hasAiLicense && user.license !== 'NONE';
};

export default useCanUseAiQa;
